(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["sticky-timer-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    if (customElements.get('sticky-bar-timer')) return;

    class StickyBarTimer extends HTMLElement {
      connectedCallback() {
        // Moving this element to <body> fires disconnect/connect again — ignore that
        if (this._moving) return;

        this.end = new Date(this.dataset.end);
        if (isNaN(this.end.getTime())) {
          this.hidden = true;
          return;
        }

        if (this.dataset.placement === 'sticky' && !this._home) this.float();

        this.tick();
        clearInterval(this.timer);
        this.timer = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        if (this._moving) return;
        clearInterval(this.timer);
        if (this._mo) this._mo.disconnect();
        if (this._ro) this._ro.disconnect();
        if (this._onScroll) {
          window.removeEventListener('scroll', this._onScroll);
          window.removeEventListener('resize', this._onScroll);
        }
        if (this._bar && this.sync) this._bar.removeEventListener('transitionend', this.sync);
      }

      // Put the strip in <body> (so nothing in the page layout can trap a fixed element)
      // and leave a tiny marker where the block is, so we know when the block goes away.
      float() {
        var section = this.closest('.shopify-section');
        var bar = section && section.querySelector('.sticky-add-to-cart__bar');
        if (!bar) return; // sticky bar is off → stay inline where the block is

        // A re-rendered block replaces any older floating copy of itself
        var id = this.dataset.blockId;
        document.querySelectorAll('body > sticky-bar-timer[data-block-id="' + id + '"]').forEach(function (old) {
          if (old !== this) old.remove();
        }, this);

        this._home = document.createElement('span');
        this._home.hidden = true;
        this._home.setAttribute('data-pst-home', id);
        this._moving = true;
        this.replaceWith(this._home);
        document.body.appendChild(this);
        this._moving = false;

        this._bar = bar;
        // the product's own Add to cart buttons (not the ones inside the sticky bar)
        this._buy = Array.prototype.find.call(section.querySelectorAll('.buy-buttons-block'), function (el) {
          return !bar.contains(el);
        }) || null;
        this.classList.add('is-floating');
        this.sync = this.sync.bind(this);
        // follow scrolling right away (not only once a second)
        this._onScroll = () => {
          if (this._raf) return;
          this._raf = requestAnimationFrame(() => {
            this._raf = 0;
            this.sync();
          });
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        window.addEventListener('resize', this._onScroll);
        bar.addEventListener('transitionend', this.sync);
        this._mo = new MutationObserver(this.sync);
        this._mo.observe(bar, { attributes: true, attributeFilter: ['data-stuck', 'style', 'class'] });
        if (window.ResizeObserver) {
          this._ro = new ResizeObserver(this.sync);
          this._ro.observe(bar);
        }
        this.sync();
      }

      // Follow the sticky bar: same height offset, show / hide together.
      // Uses what is actually on screen, not the bar's data-stuck flag: near the footer the theme
      // sets data-stuck="false" but on mobile the bar stays visible (base.css), so the timer stays too.
      sync() {
        var bar = this._bar;
        if (!bar) return;
        var cs = getComputedStyle(bar);
        var barVisible = bar.offsetHeight > 0 && cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity) > 0.05;
        var shown;
        if (this._buy) {
          // hide only while the product's own Add to cart buttons are on screen
          var r = this._buy.getBoundingClientRect();
          var buyInView = r.height > 0 && r.bottom > 0 && r.top < window.innerHeight;
          shown = barVisible && !buyInView;
        } else {
          shown = barVisible && bar.dataset.stuck === 'true';
        }
        this.style.setProperty('--pst-bottom', bar.offsetHeight + 'px');
        this.classList.toggle('is-away', !shown);
      }

      pad(n) {
        return n < 10 ? '0' + n : String(n);
      }

      tick() {
        // Block removed / re-rendered in the editor → remove this floating copy
        if (this._home && !document.contains(this._home)) {
          this.remove();
          return;
        }
        if (this._bar) this.sync();

        var total = Math.max(0, Math.floor((this.end.getTime() - Date.now()) / 1000));
        var d = Math.floor(total / 86400);
        var h = Math.floor((total % 86400) / 3600);
        var m = Math.floor((total % 3600) / 60);
        var s = total % 60;
        var text;
        if (this.dataset.format === 'hms') {
          text = this.pad(Math.floor(total / 3600)) + ':' + this.pad(m) + ':' + this.pad(s);
        } else {
          text = this.pad(h) + ':' + this.pad(m) + ':' + this.pad(s);
          if (d > 0 || this.dataset.hideZeroDays !== 'true') text = this.pad(d) + this.dataset.dayUnit + ' ' + text;
        }
        var el = this.querySelector('[data-pst-time]');
        if (el && el.textContent !== text) el.textContent = text;

        if (total <= 0) {
          clearInterval(this.timer);
          if (!(window.Shopify && window.Shopify.designMode)) this.hidden = true;
        }
      }
    }

    customElements.define('sticky-bar-timer', StickyBarTimer);
  })();
  } catch(e) { console.error(e); }
})();

})();
